import { css } from '@emotion/css';
import { cssVarV2 } from '@toeverything/theme/v2';

export const cellDivider = css({
  height: '100%',
  width: '1px',
  backgroundColor: cssVarV2.database.border,
});
